import config from '../constants/config';
import http from '../helpers/http';
import axios from "./axios";

class ProviderAPI {
    constructor() {
        this.url = `${config.baseURL}`;
        this.authorization = [];
        this.acceptLanguage = [];

        this.get = async (path) => {
            let response = await http.connect(`${this.url}${path}`, {
                type: 'GET',
                headersToAdd: [this.authorization, this.acceptLanguage]
            });
            return response && response.bodyUsed ? await response.json() : response
        };
        this.post = async (path, data) => {
            let response = await http.connect(`${this.url}${path}`, {
                type: 'POST',
                body: data,
                headersToAdd: [this.authorization, this.acceptLanguage]
            })
            return response && response.bodyUsed ? await response.json() : response
        };
        this.patch = async (path, data) => {
            let response = await http.connect(`${this.url}${path}`, {
                type: 'PATCH',
                body: data,
                headersToAdd: [
                    this.authorization,
                    this.acceptLanguage,
                    ['Prefer', 'return=representation'],
                ],
            });

            return response && response.bodyUsed ? await response.json() : response
        };
        this.delete = async (path) => {
            let response = await http.connect(`${this.url}${path}`, {
                type: 'DELETE',
                headersToAdd: [this.authorization, this.acceptLanguage]
            }, true);

            if (response.status === 204) return null;

            if (response && response.json) {

                return response;
            }
        }
    }

    // For using token in header request
    setAuthorizationHeader = token => {
       this.authorization = ['Authorization', `Bearer ${token}`];
        localStorage.setItem('Authorization', `${token}`);
    }

    setAcceptLanguageHeader = language => {
        this.acceptLanguage = ['accept-language', language]
    }

    patchProvider = async (id, data) => {
        return await this.patch(`ServiceProviders(${id})`, data);
    };

    exchangeRequestToken = async (requestToken) => {
        const res = await this.post(`api/provider/token`, requestToken);
        if (!res.token && res.status !== 200) {
            return await res.json();
        }

        return res;
    };

    resendToken = async (providerId, route, messageType) => {
        return this.post(`api/provider/${providerId}/token`, {messageType, route});
    };

    getProviderByPhone = async (phone) => {
        let results = await this.get(`ServiceProviders?$filter=id eq ${phone}`);
        if (results && results.value) {
            return results;
        }
        return null;
    }

    getProviderByID = async (id) => {
        let results = await this.get(`ServiceProviders?$filter=id eq ${id}`);
        if (results && results.value) {
            return results.value[0];
        }
        return null;
    };


    getProviderServiceCalls = async (pID) => {
        let results = await this.get(`ServiceCallExtended?$filter=ServiceProviderID eq ${pID}&$orderby=id desc`);
        if (results && results.value) {
            return results.value;
        }
        return null;
    }

    getProviderCountry = async  (coyntryId) => {
        let results = await this.get(`Countries?$filter=Id eq ${coyntryId}`);
        if (results && results.value) {
            return results.value;
        }
        return null;
    }

    getProviderSubjects = async (pID) => {
        let results = await this.get(`ServiceProviderSubjects?$filter=ProviderID eq ${pID}&$orderby=id desc`);
        if (results && results.value) {
            const activeProviderSubjects = results.value.filter(s => s.IsActive);
            const inactiveProviderSubjects = results.value.filter(s => !s.IsActive);
            return {activeProviderSubjects, inactiveProviderSubjects};
        }
        return null;
    }

    searchSubjects = async (countryId, text) => {
        let subjects = await this.post(`api/search/subjects`, {countryId, text, limit: 10});

        return subjects ? subjects.map(s => ({label: s.text, id: s.id})) : [];
    }

    postProviderSubjects = async (data) => {
        let results = await this.post(`ServiceProviderSubjects`, data);
        if (results && results.value) {
            return results.value[0];
        }
        return null;
    };

    patchProviderSubjects = async (id, data) => {
        return await this.patch(`ServiceProviderSubjects(${id})`, data);
    };

    getProviderRadiuses = async (pID) => {
        let results = await this.get(`ServiceProviderLocationCoverage?$filter=ServiceProviderID eq ${pID}`);
        if (results && results.value) {
            return results.value;
        }
        return null;
    };

    getProviderRegions = async (pID) => {
        const results = await this.get(`ServiceProvidersSubjecntNArea?$filter=ServiceProviderID eq ${pID}`);
        if (results && results.value) {
            return results.value;
        }
        return null;
    }

    getSchedule = async (pID) => {
        let results = await this.get(`ServiceProviderWorkSchedule?$filter=ServiceProviderID eq ${pID}`);
        if (results && results.value) {
            return results.value;
        }
        return null;
    };

    postSchedule = async (data) => {
        let results = await this.post(`ServiceProviderWorkSchedule`, data);
        if (results && results.value) {
            return results.value[0];
        }
        return null;
    };

    deleteSchedule = async (id) => {
        return await this.delete(`ServiceProviderWorkSchedule(${id})`);
    };

    patchSchedule = async (id, data) => {
        return await this.patch(`ServiceProviderWorkSchedule(${id})`, data);
    };


    getProviderExtended = async (pID) => {
        const provider = await this.getProviderByID(pID);
        const {activeProviderSubjects: subjects} = await this.getProviderSubjects(pID);
        const locations = await this.getProviderRadiuses(pID);

        if (!provider) return null

        provider.subjects = subjects;
        provider.locations = locations;

        return provider;
    }

    saveProviderLocations = async ({locations, provider}) => {
        const locationRows = [];
        let subjects = [];
        if (provider.subjects) {
            subjects = provider.subjects;
        } else {
            let {activeProviderSubjects: ss} = await this.getProviderSubjects(provider.id);
            subjects = ss;
        }

        for (let i = 0; i < locations.length; i++) {
            for (let j = 0; j < subjects.length; j++) {
                locationRows.push({...locations[i], ServiceSubjectID: subjects[j].id})
            }
        }

        this.post(`ServiceProviderLocationCoverage`, locationRows)
    }

    postLocationCoverage = async (data) => {
        let results = await this.post(`ServiceProviderLocationCoverage`, data);
        if (results && results.value) {
            return results.value[0];
        }
        return null;
    };

    patchLocationCoverage = async (id, data) => {
        return await this.patch(`ServiceProviderLocationCoverage(${id})`, data);
    };

    deleteLocationCoverage = async (id) => {
        return await this.delete(`ServiceProviderLocationCoverage(${id})`);
    };

    postServiceProvider = async (data) => {
        let results = await this.post(`ServiceProviders`, data);
        if (results && results.value) {
            return results.value[0];
        }
        return null;
    };

    patchServiceProvider = async (id, data) => {
        return await this.patch(`ServiceProviders(${id})`, data);
    };

    postServiceProviderLocationCoverage = async (data) => {
        let results = await this.post(`ServiceProviderAvailability`, data);
        if (results && results.value) {
            return results.value[0];
        }
        return null;
    }

    getServiceProviderAvailability = async (pID) => {
        let results = await this.get(`ServiceProviderAvailability?$filter=ServiceProviderID eq ${pID}&$orderby=NotAvailableFrom asc`);
        if (results && results.value) {
            return results.value;
        }
        return null;
    };

    patchServiceProviderAvailability = async (id, data) => {
        return await this.patch(`ServiceProviderAvailability(${id})`, data);
    };

    deleteServiceProviderAvailability = async (id) => {
        return await this.delete(`ServiceProviderAvailability(${id})`);
    };

    getTelephones = async (pID) => {
        let results = await this.get(`ServiceProviderTelephones?$filter=ServiceProviderID eq ${pID}`);
        if (results && results.value) {
            return results.value;
        }
        return null;
    };

    postTelephone = async (data) => {
        let results = await this.post(`ServiceProviderTelephones`, data);
        if (results && results.value) {
            return results.value[0];
        }
        return null;
    }

    patchTelephone = async (id, data) => {
        return await this.patch(`ServiceProviderTelephones(${id})`, data);
    };

    deleteTelephone = async (id) => {
        return await this.delete(`ServiceProviderTelephones(${id})`);
    };


    getPhonePrefixes = async (pID) => {
        let results = await this.get(`PhonePrefix`);
        if (results && results.value) {
            return results.value;
        }
        return null;
    };

    sendSMSCode = async (phone) => {
        try {
            let results = await this.post(`api/provider/login/sendVerificationSmsV2`, {
                phoneNumber: phone,
                allowRegistration: true,
                retrieveToken: false,
            });
            if (results) {
                return results;
            }
            return null;
        } catch (e) {
            return e
        }
    }

    loginProvider = async (phone, code, affiliateHash) => {
        let results = await this.post(`api/provider/loginV2`, {phoneNumber: phone, code, retrieveToken: true,affiliateHash});
        if (results) {
            return results;
        }
        return null;
    };

    createPaymentMethod = async (stripeToken) => {
        let results = await this.post(`api/provider/payment-methods/create`, {stripe_token: stripeToken});
        if (results) {
            return results;
        }
        return null;
    }

    createOfficeGuyPaymentMethod = async ({providerId, paymentMethodPayload}) => {
        let results = await this.post(`api/payment/CreatePaymentMethod/${providerId}`, paymentMethodPayload);
        if (results) {
            return results;
        }
        return null;
    }

    getPaymentMethods = async (providerId) => {
        let result = await this.get(`ServiceProviderPaymentMethods?$filter=(ServiceProviderID eq ${providerId})AND(Status eq 3)`); // active

        if (result && result.value) {
            return result.value;
        }
        return null;

    }

    setPrimaryPaymentMethod = async (paymentMethodId) => {
        return this.post(`api/provider/payment-method/${paymentMethodId}/default`);
    }

    deletePaymentMethod = async (paymentMethodId) => {
        return await this.patch(`ServiceProviderPaymentMethods(${paymentMethodId})`, {Status: 4}); // Cancelled
    }

    acquirePackage = async (packageId, paymentMethodType, providerId) => {
        let results = await this.post(`api/provider/packages/acquire`, {packageId, paymentMethodType, providerId});
        if (results) {
            return results;
        }
        return null;
    }


    getSubjectsDetails = async (subjects, CountryId) => {
        let subjectData = await this.get(`ServiceSubjects?$filter=(id in ${JSON.stringify(subjects)})`);
        let subjectPrices = await this.get(`LeadPriceList?$filter=(ServiceSubjectID in ${JSON.stringify(subjects)})AND(CountryId eq ${CountryId})`);
        if (subjectData && subjectData.value && subjectPrices && subjectPrices.value) {
            return subjectData.value.map(data => {
                let currentSubjectPrices = subjectPrices.value.find(s => s.ServiceSubjectID === data.id);
                return {...data, ...currentSubjectPrices}
            })
        }
        return null;
    }

    getPackages = async (countryId) => {
        let results = await this.get(`ServiceCallPackages?$filter=(CountryId eq ${countryId})`);

        if (results && results.value) {
            return results.value;
        }
        return null;
    }


    postServiceProviderPaymentMethods = async (data) => {
       // let results = await this.post(`ServiceProviderPaymentMethods`, data);
        const results = await axios.post(`ServiceProviderPaymentMethods`,data)
        return (results.status === 201 || results.status === 200)
    };

    initFirstPaymentMethod = async (id) => {
        let results = await this.post(`api/user/default-credit`, {
            providerId: id
        });

        if (results)
            return true;
    }


    getCountrySubjects = async (countryId) => {
        return this.get(`api/countries/${countryId}/service-fields`);
    }

    countries = [
        {
            "Id": 1,
            "Name": "Israel",
            "ShortName": "IL",
            "DisplayName": "Israel",
            "CountryPhonePrefix": "972",
            "CallCenterPhoneNumber": "+442039910630",
            "Alpha2": "IL",
            "Alpha3": "ISR",
            "Numeric": 376,
            "LanguageId": 2,
            "CurrencyId": 376,
            "IsActive": true,
            "IsMetric": true,
            "AcceptLangCode": "he-IL"
        },
        {
            "Id": 2,
            "Name": "UK",
            "ShortName": "GB",
            "DisplayName": "United Kingdom",
            "CountryPhonePrefix": "44",
            "CallCenterPhoneNumber": "+442039910630",
            "Alpha2": "GB",
            "Alpha3": "GBR",
            "Numeric": 784,
            "LanguageId": 1,
            "CurrencyId": 826,
            "IsActive": true,
            "IsMetric": false,
            "AcceptLangCode": "en-US"

        },
        {
            "Id": 3,
            "Name": "Australia",
            "ShortName": "AU",
            "DisplayName": "Australia",
            "CountryPhonePrefix": "61",
            "CallCenterPhoneNumber": "+61737031264",
            "Alpha2": "AU",
            "Alpha3": "AUS",
            "Numeric": 36,
            "LanguageId": 1,
            "CurrencyId": 36,
            "IsActive": true,
            "IsMetric": true,
            "AcceptLangCode": "en-US"
        },
        {
            "Id": 4,
            "Name": "US",
            "ShortName": "US",
            "DisplayName": "United States",
            "CountryPhonePrefix": "1",
            "CallCenterPhoneNumber": "",
            "Alpha2": "US",
            "Alpha3": "USA",
            "Numeric": 840,
            "LanguageId": 1,
            "CurrencyId": 840,
            "IsActive": true,
            "IsMetric": false,
            "AcceptLangCode": "en-US"
        }
    ]

    currencyEnums = [
        {
            "id": 36,
            "displayName": "AU$",
            "name": "AUD",
            "description": "Australian dollar"
        },
        {
            "id": 376,
            "displayName": "₪",
            "name": "ILS",
            "description": "Israeli new shekel"
        },
        {
            "id": 826,
            "displayName": "£",
            "name": "GBP",
            "description": "Pound sterling"
        },
        {
            "id": 840,
            "displayName": "US$",
            "name": "USD",
            "description": "United States dollar"
        },
        {
            "id": 978,
            "displayName": "€",
            "name": "EUR",
            "description": "Euro"
        }
    ]
}

export default new ProviderAPI()
